<template>
  <b-container>
    <b-card title="Buscar Usuário">
      <b-col
        cols="12"
        md="12"
        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
      >
        <b-form-input
          v-model="filter"
          placeholder="Informe o Nome do Funcionário"
          type="text"
          class="d-inline-block mr-1"
        />

        <b-button
          variant="primary"
          :to="{ name: 'create-creditplatform-user' }"
        >
          <span class="text-nowrap">Novo Usuário</span>
        </b-button>
      </b-col>
    </b-card>
    <b-card>
      <b-table
        :per-page="perPage"
        :current-page="currentPage"
        :fields="table_users_fields"
        :items="users"
        :filter="filter"
        striped
        hover
        responsive
        :busy="isLoading"
        class="text-center"
        :tbody-tr-class="rowRevoked"
        @filtered="onFiltered"
      >
        <template #cell(masterUser)="data">
          <b-badge
            pill
            :variant="data.item.masterUser ? 'success': 'danger'"
          >
            {{ data.item.masterUser ? "SIM" : "NÃO" }}
          </b-badge>
        </template>

        <template #cell(group)="data">
          {{ data.item.group.name }}
        </template>

        <template #cell(createdAt)="data">
          {{ data.item.createdAt | date }}
        </template>
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item
              :to="{ name: 'edit-creditplatform-user', params: { id: data.item.id } }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Editar</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="data.item.isRevoked !== 1"
              @click="modalRevoked(data)"
            >
              <feather-icon icon="XCircleIcon" />
              <span class="align-middle ml-50">Revogar</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
      <b-pagination
        v-if="!isLoading"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="center"
        size="sm"
        class="my-0"
      />
    </b-card>
  </b-container>
</template>
<script>
import {
    BContainer,
    BTable,
    BButton,
    BPagination,
    BCard,
    BCol,
    BFormInput,
    BDropdown,
    BDropdownItem,
    BSpinner,
    BBadge,
} from 'bootstrap-vue';
import GroupsService from '@/service/credit_platform/groups';

export default {
    components: {
        BContainer,
        BCol,
        BTable,
        BButton,
        BPagination,
        BCard,
        BFormInput,
        BDropdown,
        BDropdownItem,
        BSpinner,
        BBadge,
    },
    data() {
        return {
            filter: null,
            perPage: 8,
            totalRows: null,
            currentPage: 1,
            isLoading: false,
            detailsClassFn: 'is-revoked',
            table_users_fields: [
                { key: 'name', label: 'Nome' },
                { key: 'email', label: 'email' },
                { key: 'masterUser', label: 'Usuário Master?' },
                { key: 'group', label: 'grupo' },
                { key: 'createdAt', label: 'Criado em' },
                { key: 'actions', label: 'Ações' },
            ],
            users: null,
        };
    },
    async mounted() {
        await this.listAllUsers();
    },
    methods: {
        rowRevoked(item) {
            return item?.isRevoked === 1 ? 'is-revoked' : '';
        },
        async revokeUser(id) {
            this.isLoading = true;
            const response = await GroupsService.updateUser({ is_revoked: true }, id);
            this.responseModal(response.status === 200);

            if (response.status === 200) {
                const indexUser = this.users.findIndex(user => user.id === id);
                this.users[indexUser] = this.users[indexUser].isRevoked = 1;
            }
            this.isLoading = false;
        },
        responseModal(success, user) {
            if (success) {
                this.$swal({
                    icon: 'success',
                    html: '<span>O usuário foi revogado com sucesso </span>',
                });
            } else {
                this.$swal({
                    icon: 'error',
                    html: '<span> Não foi possível revogar o usuário  </span>',
                });
            }
        },
        modalRevoked({ item }) {
            this.$bvModal
                .msgBoxConfirm('Deseja realmente revogar o usuário?', {
                    cancelVariant: 'outline-secondary',
                    centered: true,
                    okTitle: 'Sim',
                    cancelTitle: 'Não',
                })
                .then(value => {
                    if (value) { this.revokeUser(item.id); }
                });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        async listAllUsers() {
            this.isLoading = true;

            const { data: { data } } = await GroupsService.getAllUsers();

            this.totalRows = data.length;

            const usersList = data.map(group => ({
                id: group.id,
                email: group.email,
                group: group.group,
                masterUser: group.master_user,
                createdAt: group.created_at,
                isRevoked: group.is_revoked,
                name: group.name,
            }));

            this.users = usersList.sort((a, b) => (a.name.localeCompare(b.name)));
            this.isLoading = false;
        },
    },
};
</script>

    <style lang="scss">
      .is-revoked {
        background-color: rgba(0, 0, 0 , .09) !important;
        &:hover{
          background-color: rgba(0, 0, 0 , .11) !important;
        }
      }
    </style>
